<template>
  <div class="allTabs mt-10">
    <v-row dense>
      <v-col cols="7" sm="9" md="10">
        <v-text-field v-model="search" prepend-icon="mdi-magnify" label="Search with trading account ..." single-line
          solo hide-details class="input-search"></v-text-field>
      </v-col>
      <v-col cols="5" sm="3" md="2">
        <v-select v-model="selectedAccountNo" solo :items="accountNumbers" append-icon="mdi-chevron-down"
          label="Account No" class="custom-select"></v-select>
      </v-col>
    </v-row>
    <v-row dense class="mt-2">
      <v-skeleton-loader v-if="loading" type="card" class="mt-5" :loading="true" width="400"></v-skeleton-loader>
      <v-col md="6" sm="6" lg="4" v-for="account in filteredAccounts" :key="account.id" v-if="!loading">
        <v-card class="elevation-0 rounded-0 live-account-card" :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
          <v-card-actions>
            <div class="trade-status">
              <div>
                <v-icon color="#647E98">mdi-arrow-top-left</v-icon>
              </div>
              <div class="trade-number">
                <span class="text-red">Demo -
                  {{ account?.tradingaccounttypes?.account_type_display }}</span>
                <span>{{ account?.trading_account_no }}</span>
                <span>{{ account?.tradeNumber }}</span>
              </div>
            </div>
            <v-spacer></v-spacer>
          </v-card-actions>
          <v-card-actions>
            <div class="value-trades mb-0">
              <span>Status</span>
              <span style="font-size: 16px">{{
                account?.status === 1 ? "Active" : "Inactive"
              }}</span>
            </div>
            <v-spacer></v-spacer>
            <div class="value-trades mb-0">
              <span>Currency</span>
              <span>{{ account?.currency_name }}</span>
            </div>
          </v-card-actions>
          <v-card-actions>
            <v-sheet :color="$vuetify.theme.dark ? 'transparent ' : 'transparent'">
              <div>
                <apexChart width="100%" height="85px" type="line" :options="options" :series="series">
                </apexChart>
              </div>
            </v-sheet>
          </v-card-actions>
          <v-card-actions>
            <div class="currency-leverage">
              <span>Date</span>
              <span>{{ account?.created_at }}</span>
            </div>
            <v-spacer></v-spacer>
            <div class="currency-leverage">
              <span>Leverage</span>
              <span>{{ `1:${account?.leverage}` }}</span>
            </div>
          </v-card-actions>
          <v-card-actions>
            <!-- <div class="balance-equity">
              <span>Free Margin</span>
              <span>{{ account?.MarginFree }}</span>
            </div> -->
            <v-spacer></v-spacer>
            <!-- <div class="balance-equity">
              <span>Acc. Type</span>
              <span>{{
                account?.tradingaccounttypes?.account_type_display
              }}</span>
            </div> -->
          </v-card-actions>
          <!-- <v-card-actions class="pb-0">
            <v-btn :to="{ path: 'demo-account-details', query: { id: account.id } }" block outlined class="blink"> See
              Details </v-btn>
          </v-card-actions> -->
        </v-card>
      </v-col>
      <v-col md="12" sm="12">
        <p class="text-center" v-if="!filteredAccounts?.length">No Demo Account Found</p>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { TRADING__ACTIONS } from "@/store/action-types";

export default {
  data() {
    return {
      search: "",
      loading:false,
      selectedAccountNo: "All",
      slots: ["USD", "INR", "JPY"],
      options: {
        chart: {
          type: "line",
          toolbar: {
            show: false,
          },
        },
        xaxis: {
          labels: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
        },
        yaxis: {
          labels: {
            show: false,
          },
        },
        grid: {
          show: false,
        },
        stroke: {
          width: 2,
        },
        dataLabels: {
          enabled: false,
        },
        colors: ["#3A648E"],
      },
      series: [
        {
          name: "Series 1",
          data: [45, 52, 38, 45, 19, 23, 2],
        },
      ],
    };
  },
  computed: {
    ...mapState("trading", ["demoAccounts"]),
    filteredAccounts() {
      return this.demoAccounts.filter((account) => {
        const matchesSearch = Object.values(account).some(value =>
          String(value).toLowerCase().includes(this.search.toLowerCase())
        );
        const matchesAccountNo = this.selectedAccountNo === "All" || account.trading_account_no === this.selectedAccountNo;
        return matchesSearch && matchesAccountNo;
      });
    },

    accountNumbers() {
      const uniqueAccountNumbers = [...new Set(this.demoAccounts.map(account => account.trading_account_no))];
      return ["All", ...uniqueAccountNumbers];
    },
  },
  methods: {
    ...mapActions("trading", [TRADING__ACTIONS.DEMOACCOUNTS]),
  },
  async mounted() {
    this.loading = true;
    try {
      await this.DEMOACCOUNTS();
    } catch (error) {
      console.error("Error fetching demo accounts:", error);
    } finally {
      this.loading = false;
    }
  },
};
</script>

<style>
.v-skeleton-loader__card-heading {
  opacity: .3 !important;
}

.v-skeleton-loader__image{
  opacity: .3 !important;
}
</style>
